import React, { useState } from 'react'
import { ActionButton } from '../../ActionButton'
import { useEthers } from '../../../../hooks'
import { ConfirmClaim } from './ConfirmClaim'
import { StakingOption } from '../utils'
import { usePositions } from '../usePositions'
import { useConnectModal } from '../../../../providers'

interface Props {
  className?: string
  stakingOption: StakingOption
}

export function ClaimButton({ className, stakingOption }: Props) {
  const { account } = useEthers()
  const { setConnectModalOpen } = useConnectModal()
  const [open, setOpen] = useState(false)
  const { claimable } = usePositions(stakingOption)
  const disabled = account && !claimable?.value.gt(0)

  return (
    <>
      <ActionButton
        className={className}
        disabled={disabled}
        onClick={() => {
          if (!account) {
            setConnectModalOpen()
            return
          }

          setOpen(true)
        }}
      >
        Claim
      </ActionButton>
      {open && (
        <ConfirmClaim stakingOption={stakingOption} onClose={() => setOpen(false)} onSubmit={() => setOpen(false)} />
      )}
    </>
  )
}
